import { Box, Container } from '@mui/material';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { RootState } from './app/store';
import Footer from './components/Footer';
import InProgressBar from './components/InProgressBar';
import Menu from './components/Menu';
import Navbar from './components/Navbar';
import { DRAWER_WIDTH } from './constants';
import { useAppDispatch } from './hook/useAppRudux';
import AlertBox from './pages/AlertBox';
import Error403 from './pages/Error/403';
import Error404 from './pages/Error/404';
import Home from './pages/Home';
import loadingSlice from './pages/Loading/loadingSlice';
import ResetPassword from './pages/ResetPassword';
import Service from './pages/Service';

export default function App() {
  const dispatch = useAppDispatch();
  const { openAlert, duration, status, message, isLoading } = useSelector(
    (state: RootState) => state.loading
  );

  const [openDrawer, setOpenDrawer] = useState<boolean>(false);

  function handleDrawer(open: boolean) {
    return (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }
      setOpenDrawer(open);
    };
  }

  return (
    <div>
      <AlertBox
        open={openAlert}
        onClose={() => dispatch(loadingSlice.actions.clear())}
        autoHideDuration={duration}
        severity={status}
      >
        {message}
      </AlertBox>
      {isLoading && <InProgressBar />}
      <Box sx={{ ml: { lg: `${DRAWER_WIDTH}px` } }}>
        <Navbar handleDrawer={handleDrawer} />
        <Menu openDrawer={openDrawer} onCloseDrawer={handleDrawer(false)} />
        <Container id="container" sx={{ mt: { xs: 8.5, sm: 9.5 } }}>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/services" component={Service} />
            <Route
              exact
              path="/account"
              component={() => <Redirect to="/" />}
            />
            <Route exact path="/login" component={() => <Redirect to="/" />} />
            <Route path="/reset-passwords" component={ResetPassword} />
            <Route exact path="/error/403" component={Error403} />
            <Route exact path="/error/404" component={Error404} />
            <Route
              exact
              path="*"
              component={() => <Redirect to="/error/404" />}
            />
          </Switch>
        </Container>
        <Footer />
      </Box>
    </div>
  );
}
